import { render, staticRenderFns } from "./CalendarioProgramacao.vue?vue&type=template&id=215b94a0&scoped=true"
import script from "./CalendarioProgramacao.vue?vue&type=script&lang=js"
export * from "./CalendarioProgramacao.vue?vue&type=script&lang=js"
import style0 from "./CalendarioProgramacao.vue?vue&type=style&index=0&id=215b94a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215b94a0",
  null
  
)

export default component.exports